<template>
  <Dialog :visible="visible" modal :header="workshop?.workshopTitle"
    :style="{ width: '50rem' }" class="mx-2 sm:mx-4 workshop-participants-dialog"
    @update:visible="$emit('update:visible', $event)">
    <div class="text-base sm:text-xl flex flex-wrap break-words">
      {{ $t('WorkshopComponent.Facilitator') }}:
      {{ workshop?.workshopFacilitator?.name }}
    </div>
    <p class="text-[var(--color-orange)] font-medium mt-3 text-sm sm:text-base flex items-center gap-1">
      <font-awesome-icon icon="fa-calendar" class="shrink-0" />
      {{ formattedDate }}
    </p>
    <p class="text-sm sm:text-base mt-2">{{ $t('WorkshopComponent.SendReflectionToAllParticipant') }}</p>
    <div class="flex flex-wrap gap-2 my-4">
      <span
        v-for="participant in (workshop?.participants || [])"
        :key="participant._id || participant.name"
        @click="onToggleParticipant(participant)"
        class="text-xs sm:text-sm py-1.5 px-3 sm:px-4 text-white min-w-20 text-center rounded-full cursor-pointer"
        :class="isSelected(participant) ? 'bg-[var(--color-orange)]' : 'bg-[var(--color-disabled)]'">
        {{ participant.name }}
      </span>
    </div>
    <div class="flex justify-end mt-6">
      <Button type="button" class="btn-primary-accent w-full sm:w-auto"
        :disabled="submitting"
        @click="onSubmit" unstyled>
        {{ $t('WorkshopComponent.SendReflection') }}
      </Button>
    </div>
  </Dialog>
</template>
<script>
import { Dialog, Button } from 'primevue';

export default {
  name: 'WorkshopParticipantsOverlayComponent',
  emits: ['update:visible'],
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  components: { Dialog, Button },
  data() {
    return {
      selectedParticipants: this.$store.getters.currentSelectedWorkshop.participants || [],
      submitting: false,
    };
  },
  computed: {
    workshop() {
      return this.$store.getters.currentSelectedWorkshop;
    },
    formattedDate() {
      const date = new Date(this.workshop.createdAt);
      return `${`0${date.getDate()}`.slice(-2)}.${`0${date.getMonth() + 1}`.slice(
        -2,
      )}.${date.getFullYear()}`;
    },
  },
  methods: {
    async onSubmit() {
      if (this.submitting) return;
      if (this.selectedParticipants.length === 0) {
        this.$toast.add({
          severity: 'error',
          summary: this.$t('WorkshopComponent.YouNeedToChooseAtLeastOneParticipant'),
          detail: '',
          life: 3000,
        });
        return;
      }

      this.submitting = true;
      try {
        await this.$store.dispatch('sendReflexionWorkshop', {
          workshopId: this.workshop._id,
          participants: this.selectedParticipants.map((s) => s._id),
        });
        this.$toast.add({
          severity: 'success',
          summary: this.$t('ToastComponent.workshop.workshopSendReflection'),
          detail: '',
          life: 3000,
        });
        this.$emit('update:visible', false);
      } catch (error) {
        this.$toast.add({
          severity: 'error',
          summary: this.$t('ToastComponent.workshop.workshopSendReflectionError'),
          detail: '',
          life: 3000,
        });
      } finally {
        this.submitting = false;
      }
    },
    onToggleParticipant(participant) {
      if (this.isSelected(participant)) {
        this.selectedParticipants = this.selectedParticipants.filter(
          (s) => s._id !== participant._id,
        );
      } else this.selectedParticipants.push(participant);
    },
    isSelected(participant) {
      return !!this.selectedParticipants.find((s) => s._id === participant._id);
    },
  },
};
</script>

<style scoped>
@media (max-width: 640px) {
  :deep(.p-dialog) {
    width: calc(100vw - 1rem) !important;
    max-width: calc(100vw - 1rem);
  }
}
</style>
